import { keymirror } from 'utils/keymirror'

export const ETA_ACTION_TYPES = keymirror({
  SIDEBAR_ETA: null,
})

export const GEOCODE_ACTION_TYPES = keymirror({
  REQUEST_GEOCODE: null,
  GEOCODE_SUCCESS: null,
  GEOCODE_FAILURE: null,
})

export const PREVIOUS_DIRECTIONS_ACTION_TYPES = keymirror({
  PREVIOUS_DIRECTIONS_REQUEST: null,
  PREVIOUS_DIRECTIONS_SUCCESS: null,
  PREVIOUS_DIRECTIONS_FAILURE: null,
})

export const PREDICTED_DIRECTIONS_ACTION_TYPES = keymirror({
  PREDICTED_DIRECTIONS_REQUEST: null,
  PREDICTED_DIRECTIONS_SUCCESS: null,
  PREDICTED_DIRECTIONS_FAILURE: null,
})

export const getMapboxEta = (type, shipment) => ({
  payload: { shipment },
  type,
})

export const getGeoCode = latLng => {
  const latLngString = `${latLng.lng},${latLng.lat}`
  const url = 'https://api.mapbox.com/geocoding/v5/mapbox.places/'
  const docType = '.json'
  const fullUrl = `${url}${latLngString}${docType}/?access_token=${__MAPBOX_TOKEN__}`
  return {
    payload: {
      callApi: true,
      requestData: {
        endpoint: { url: fullUrl },
      },
      actionTypes: Object.keys(GEOCODE_ACTION_TYPES),
    },
  }
}

export const getDirections = (
  waypoints,
  stopsData,
  actionTypes = PREDICTED_DIRECTIONS_ACTION_TYPES
) => {
  const url = 'https://api.mapbox.com/directions/v5/mapbox/driving/'
  const waypointsString = waypoints.join(';')
  const params = `?geometries=geojson&access_token=${__MAPBOX_TOKEN__}&exclude=ferry`
  const fullUrl = `${url}${waypointsString}${params}`
  return {
    data: { ...stopsData },
    payload: {
      callApi: true,
      requestData: {
        endpoint: { url: fullUrl },
      },
      actionTypes: Object.keys(actionTypes),
    },
  }
}
